<template>
  <div class="right-box">
    <div class="option-box">
<!--      <div class="right-option-item" @touchstart="openSpecialSub">-->
<!--        <img src="../../assets/img/phone/video.png" class="option-icon video-icon" alt="" />-->
<!--        <p class="option-text">专题片</p>-->

<!--      </div>-->
      <div class="right-option-item" @touchstart="triggerBgMusic">
        <img src="../../assets/img/phone/audio.png" v-if="musicPlay" class="option-icon audio-icon" alt="" />
        <img src="../../assets/img/phone/audio-off.png" v-if="!musicPlay" class="option-icon audio-icon" alt="" />
        <p class="option-text">声音</p>

      </div>

      <div class="right-option-item heart-box">
        <img src="../../assets/img/phone/heart.png" class="option-icon heart-icon" alt="" />
        <p class="option-text">点赞</p>

      </div>

      <div class="right-option-item" @touchstart="openMessage">
        <img src="../../assets/img/phone/message.png" class="option-icon message-icon" alt="" />
        <p class="option-text">留言</p>

      </div>
      <!-- <div class="right-option-item" @click="candleClick">
        <img
          src="../../assets/img/phone/share.png"
          class="option-icon share-icon"
          alt=""
        />
       
        <p class="option-text">分享</p>
      </div> -->
    </div>
    <specialSubjectPhone :showSpecial="showSpecial" @closeSpecialSub="closeSpecialSub"></specialSubjectPhone>
    <audio  crossOrigin="anonymous" src="audio/0_1_1.mp3" autoplay id="audio"></audio>
    <audio  crossOrigin="anonymous" src="audio/bg/0_1_1_bg.mp3" autoplay loop id="bgaudio"></audio>
  </div>
</template>

<script>
import BubbleHearts from "../../utils/flutter-hearts-zmt";
import { giveThumbsUp, cityInfo } from "@/utils/tools.js"
import specialSubjectPhone from "./specialSubjectPhone.vue";
import { init_music,close_music,open_music,stop_music } from "../../utils/audio";
export default {
  data() {
    return {
      musicPlay: true,
      zanNum: "",
      numShow: false,
      showSpecial:false
    };
  },
  components: {
    specialSubjectPhone
  },
  props: {
    krpano: ""
  },
  methods: {
    candleClick() {
      this.$emit("candleClick");
    },
    //音频播放
    playBgMusic(val) {
      if (val) {
        init_music()
 
      } else {
        stop_music()
      }
    },
    triggerBgMusic() {
      this.musicPlay = !this.musicPlay;
  
      this.playBgMusic(this.musicPlay)
      
    },
    canvasShow(time) {
      var that = this;

      document.querySelector("#canvas_id").style.display = "block";
      that.numShow = true;
      if (time) {
        clearTimeout(time);
      }
      return (time = setTimeout(() => {
        document.querySelector("#canvas_id").style.display = "none";
        that.numShow = false;
        clearTimeout(time);
      }, 3000));
    },
    giveZan() {

      var that = this;
      let scene_name = this.krpano.get("xml.scene");
      let sceneShortName = scene_name.split("_")[1] + "_" + scene_name.split("_")[2]
      let activeCity = cityInfo.filter(item => item.sceneName == sceneShortName)[0]
      if (!activeCity) {
        const random = (min, max) => Math.floor(Math.random() * (max - min) + min); //随机数方法
        let index = random(0, cityInfo.length); //生成一个从最小值为0 最大值为数组长度的随机数

        activeCity = cityInfo[index]
      }

      giveThumbsUp(15982, activeCity.groupId, activeCity.id)
    },
    openMessage() {
      this.$emit("openMessage")
    },
    // 专题片
    openSpecialSub(){
      this.showSpecial = true;
    },
    closeSpecialSub(){
     
      this.showSpecial = false
    }
  },
  mounted() {
    let _this = this;

    // 点赞飘心
    var assets = [
      "./images/zan/1.png",
      "./images/zan/2.png",
      "./images/zan/3.png",
      "./images/zan/4.png",
      "./images/zan/5.png",
      "./images/zan/6.png",
      "./images/zan/7.png",
    ];
    assets.forEach(function (src, index) {
      assets[index] = new Promise(function (resolve) {
        var img = new Image();
        img.onload = resolve.bind(null, img);
        img.src = src;
      });
    });

    Promise.all(assets).then(function (images) {
      var random = {
        uniform: function (min, max) {
          return min + (max - min) * Math.random();
        },
        uniformDiscrete: function (i, j) {
          return i + Math.floor((j - i + 1) * random.uniform(0, 1));
        },
      };
      var stage = new BubbleHearts();
      var canvas = stage.canvas;
      canvas.width = 170;
      canvas.height = 300;
      canvas.id = "canvas_id";
      canvas.style["width"] = "1.50rem";
      canvas.style["height"] = "3.00rem";
      document.getElementsByClassName("heart-box")[0].appendChild(canvas);

      let time = null;

      document.getElementsByClassName("heart-box")[0].addEventListener(
        "touchend",
        function () {
          time = _this.canvasShow.apply(this, [time]);

          _this.giveZan();

          stage.bubble(images[random.uniformDiscrete(0, images.length - 1)]);
        },
        false
      );
    });
    // 点赞飘心 end

    // 声音控制
    this.audio = document.querySelector("#audio");

    //----------处理页面激活------------
    var hiddenProperty =
      "hidden" in document
        ? "hidden"
        : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
            ? "mozHidden"
            : null;
    var visibilityChangeEvent = hiddenProperty.replace(
      /hidden/i,
      "visibilitychange"
    );
    var onVisibilityChange = function () {
      var videoPlayState1 = _this.krpano.get("videoPlayState1");
      if (!document[hiddenProperty]) {
     
        if (videoPlayState1) {
          _this.krpano.call('hotspot["videospot"].play()');
        }else{
          open_music();
        }
      } else {
        close_music()
        if (videoPlayState1 !== undefined && videoPlayState1 !== null) {
          _this.krpano.call('hotspot["videospot"].pause()');
        }

      }
    };
    document.addEventListener(visibilityChangeEvent, onVisibilityChange);
 
    // 声音控制end
    window.playBgMusic = this.playBgMusic
  },
  created() { },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.numShow-enter-active,
.numShow-leave-active {
  transition: all 1s;
}

.numShow-enter,
.numShow-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
  transform: translateY(0.3rem);
}

.right-box {
  width: 1rem;
  position: absolute;
  right: 0.56rem;
  top: 6.2rem;
  // background-color: rgba($color: #000000, $alpha: 0.6);

  .option-box {
    width: 100%;
 
    height: 100%;
    display: flex;

    justify-content: space-between;
    flex-direction: column;

    .right-option-item {
      width: 100%;
      text-align: center;
      position: relative;
      margin-bottom: 0.5rem;
       
      .audio-icon {
        width: 0.81rem;
        //height: 0.38rem;
      }

      .candle-icon {
        width: 0.81rem;
        //height: 0.38rem;
      }

      .heart-icon {
        width: 0.81rem;
        //height: 0.38rem;
      }

      .video-icon {
        width: 0.81rem;
      }

      .message-icon {
        width: 0.81rem;
        //height: 0.38rem;
      }

      .share-icon {
        width: 0.81rem;
        //height: 0.38rem;
      }

      .option-text {
        font-size: 0.24rem;
        color: #fff;
        font-weight: 500;
        text-align: center;
      }
    }
  }
}
</style>
<style>
#canvas_id {
  position: absolute;
  top: -2.2rem;
  left: -2rem;
  display: none;
  transform: rotate(-60deg);
}
</style>